import {
    REQUEST_CALENDAR_EVENTS,
    RECEIVE_CALENDAR_EVENTS,
    UPDATE_CALENDAR_EVENTS,
    ERROR_CALENDAR_EVENTS
} from '../types'
import {initialFetchState} from "../../constants/defaultValues"
import _get from "lodash/get"
import _cloneDeep from 'lodash/cloneDeep'

export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_CALENDAR_EVENTS:
            newState[action.identifier] = {
                ...initialFetchState,
                data: _get(newState, [action.identifier, 'data'], []),
                isFetching: true
            }
            return newState
        case RECEIVE_CALENDAR_EVENTS:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: action.payload,
                message: '',
                errors: {}
            }
            return newState
        case UPDATE_CALENDAR_EVENTS:
            const data = newState[action.identifier].data || []
            let index = null
            if(action.updateType == "delete"){
                index = data.findIndex(item => item.id == action.id)
                data.splice(index, 1)
            }else{
                index = data.findIndex(item => item.id == action.id)
                if(index > -1){
                    data[index] = {...data[index], ...action.payload}
                }else{
                    data.push(action.payload)
                }
            }
            newState[action.identifier] = {
                ...newState[action.identifier],
                data,
                isFetching: false
            }
            return newState
        case ERROR_CALENDAR_EVENTS:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: [],
                message: action.errors.server || '',
                errors: action.errors
            }
            return newState
        default:
            return state
    }
}